
import DefaultTenant from './Default'

export default {
  ...DefaultTenant,
  "title": "Client A",
  "homepageBackgroundImg": "/homepage/ClientA.jpg",
  "callToAction": {
    "backgroundColor": "#4098D7",
  },
  "nomenclature": {
    "partition": {
      "singular": "Partition",
      "plural": "Partitions"
    }
  },
  "mapMultiselect": false,
  "mapClusters": false,
}
